import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createAssociations, getAssociation, resetState, updateAssociation } from "../features/association/associationSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  shortName: yup.string().required("Short Name is Required"),
  email: yup.string().required("Email is Required"),
  password: yup.string().required("Password is Required"),
  type: yup.string().required("Type is Required"),
});

const AddAssociation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.association);
  const { isSuccess, isError, isLoading, createdAssociation, associationName, associationshortName, associationemail, associationPassword, associationtype, updatedAssociation } = NewsState;
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState("");
  

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getAssociation(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdAssociation) {
      toast.success("Association Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedAssociation) {
      toast.success("Association Updated Successfully!");
      navigate("/admin/Association-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
      name: associationName || "",
      shortName:associationshortName ||"",
      type:associationtype ||"",
      email:associationemail ||"",
      password:associationPassword ||""
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (!image ) {
        setImageError("Please select an image.");
        return;
      } else {
        setImageError("");
      }
      
      const formData = new FormData();
      
      formData.append("name", values.name);
      formData.append("shortName", values.shortName);
      formData.append("type", values.type);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("image", image);
      
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updateAssociation(data));
        dispatch(resetState());
      } else {
        dispatch(createAssociations(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Association</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Association Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              val={formik.values.name}
            />
            <div className="error">{formik.touched.name && formik.errors.name}</div>
          </div>

          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Association Short Name"
              name="shortName"
              onChng={formik.handleChange("shortName")}
              onBlr={formik.handleBlur("shortName")}
              val={formik.values.shortName}
            />
            <div className="error">{formik.touched.shortName && formik.errors.shortName}</div>
          </div>

          <select
            name="type"
            onChange={formik.handleChange("type")}
            onBlur={formik.handleBlur("type")}
            value={formik.values.type}
            className="form-control py-3 mt-3"

          >
            <option value="">Select Status Category</option>
            <option value="National">National</option>
            <option value="Regional">Regional</option>
            <option value="International">International</option>
          
          </select>
          <div className="error">{formik.touched.type && formik.errors.type}</div>
  
          <div className="mt-4">
          <CustomInput
            type="text"
            label="Email Address"
           
            name="email"
            val={formik.values.email}
            onChng={formik.handleChange("email")}
            onBlr={formik.handleBlur("email")}
          />
           <div className="error">{formik.touched.email && formik.errors.email}</div>
          </div>
          <div className="mt-4">
          <CustomInput
            type="password"
            label="Password"
            name="password"
            
            onChng={formik.handleChange("password")}
            onBlr={formik.handleBlur("password")}
          />
           <div className="error">{formik.touched.password && formik.errors.password}</div>
          </div>
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Logo
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                setImage(e.target.files[0]);
                setImageError(""); 
              }}
              className="form-control"
            />
            <div className="error">{imageError}</div>
          </div>

          

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Association
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddAssociation;